/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endsnextdayhint3Inputs */

const en_endsnextdayhint3 = /** @type {(inputs: Endsnextdayhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ends the next day`)
};

const de_endsnextdayhint3 = /** @type {(inputs: Endsnextdayhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endet am nächsten Tag`)
};

/**
* | output |
* | --- |
* | "Ends the next day" |
*
* @param {Endsnextdayhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const endsnextdayhint3 = /** @type {((inputs?: Endsnextdayhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endsnextdayhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_endsnextdayhint3(inputs)
	return de_endsnextdayhint3(inputs)
});
export { endsnextdayhint3 as "endsNextDayHint" }